module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_ALOEVIA.0f192edb.png";